import React, { useEffect, useState } from 'react';
import moment from 'moment';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import Indicator from '../../../components/indicator/Indicator';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';

function MeasurementIndicator(props) {
    const [local_data_ok, setLocal_Data_ok] = useState(false);
    const [data_uioption, setData_uioption] = useState({});
    const [data_status_indicator, setData_status_indicator] = useState({
        update_time: '-',
        meter_solar_alarm: [],
        inverter_alarm: [],
    });
    const [data_status_common, setData_status_common] = useState({
        center_chow_ok: false,
        center_cpf_ok: false,
        iot_device: true,
        alarmcount_alarm: 0,
        alarmcount_warning: 0,
        upgrading: false,
    });

    useEffect(() => {
        return () => {
            setData_status_indicator({})
            setData_uioption({})
        };
    }, []);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            setData_uioption(props.data_uioption)
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.local_data_ok !== undefined) {
            setLocal_Data_ok(props.local_data_ok)
        }
    }, [props.local_data_ok]);

    useEffect(() => {
        if (props.data_status_indicator !== undefined) {
            if (props.data_status_indicator.inverter_alarm !== undefined) {
                setData_status_indicator(props.data_status_indicator)
            }
        }
    }, [props.data_status_indicator]);

    useEffect(() => {
        if (props.data_status_common !== undefined) {
            setData_status_common(props.data_status_common)
        }
    }, [props.data_status_common]);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-widgets-outline color-orange"></i> Status Indicator</h4>
                                    <p className="mb-1">Monitoring all status of solar system</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="row">
                        <div className='col-12'>
                            <div className='d-flex flex-wrap d-xl-none mb-3 pb-2 border-bottom'>
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Power Limit"}
                                    value={data_status_indicator.power_limit}
                                    message_good={"Inverter Limit"}
                                    message_bad={"No Limit"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"warning-orange"}
                                    cls_inactive={"alarmevent-bg-grey"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Local API"}
                                    value={props.local_api_state === 2 ? true : false}
                                    message_good={"Connected"}
                                    message_bad={"Disconnected"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"normal"}
                                    cls_inactive={"alarming"}
                                />
                            </div>
                            <div className='d-flex flex-wrap mb-3 pb-2 border-bottom'>
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Irradiation #1"}
                                    value={data_status_indicator.sensor_alert_irr1}
                                    message_good={"Sensor Abnormal"}
                                    message_bad={"Sensor OK"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                {
                                    data_uioption?.has_irr2 === true ?
                                        <Indicator
                                            data_ok={local_data_ok}
                                            verify={true}
                                            name={"Irradiation #2"}
                                            value={data_status_indicator.sensor_alert_irr2}
                                            message_good={"Sensor Abnormal"}
                                            message_bad={"Sensor OK"}
                                            message_unknown={"Recieving Status"}
                                            cls_active={"alarming"}
                                            cls_inactive={"normal"}
                                        />
                                        :
                                        null
                                }
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Ambient Temperature"}
                                    value={data_status_indicator.sensor_alert_temp_ambient}
                                    message_good={"Sensor Abnormal"}
                                    message_bad={"Sensor OK"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Relative Humidity"}
                                    value={data_status_indicator.sensor_alert_humidity}
                                    message_good={"Sensor Abnormal"}
                                    message_bad={"Sensor OK"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"PV Temperature"}
                                    value={data_status_indicator.sensor_alert_temp_pv}
                                    message_good={"Sensor Abnormal"}
                                    message_bad={"Sensor OK"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Cable Tray Temperature"}
                                    value={data_status_indicator.sensor_alert_temp_tray}
                                    message_good={"Sensor Abnormal"}
                                    message_bad={"Sensor OK"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                {
                                    data_uioption?.has_windspeed === true ?
                                        <>
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={true}
                                                name={"Wind Speed"}
                                                value={data_status_indicator.sensor_alert_wind_speed}
                                                message_good={"Sensor Abnormal"}
                                                message_bad={"Sensor OK"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={true}
                                                name={"Wind Direction"}
                                                value={data_status_indicator.sensor_alert_wind_direction}
                                                message_good={"Sensor Abnormal"}
                                                message_bad={"Sensor OK"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                        </>
                                        :
                                        null
                                }
                                {
                                    data_uioption?.has_waterlevel === true ?
                                        <Indicator
                                            data_ok={local_data_ok}
                                            verify={true}
                                            name={"Water Level"}
                                            value={data_status_indicator.sensor_alert_water_level}
                                            message_good={"Sensor Abnormal"}
                                            message_bad={"Sensor OK"}
                                            message_unknown={"Recieving Status"}
                                            cls_active={"alarming"}
                                            cls_inactive={"normal"}
                                        />
                                        :
                                        null
                                }
                            </div>
                            <div className='d-flex flex-wrap mb-3 pb-2 border-bottom'>
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={data_status_indicator.plc_alarm}
                                    name={"Main MCCB #1"}
                                    value={data_status_indicator.MCB1_Status_On}
                                    message_good={"Status On"}
                                    message_bad={"Status Off"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"normal"}
                                    cls_inactive={"alarming"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={data_status_indicator.plc_alarm}
                                    name={"Emergency #1"}
                                    value={data_status_indicator.MCB1_Emergency_Switch}
                                    message_good={"Detected"}
                                    message_bad={"Normal State"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={data_status_indicator.plc_alarm}
                                    name={"AC Shutdown #1 CMD"}
                                    value={data_status_indicator.FB_Remote_MCB1_Trip_Main_CMD}
                                    message_good={"Active"}
                                    message_bad={"Normal State"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={data_status_indicator.plc_alarm}
                                    name={"DC Shutdown #1 CMD"}
                                    value={data_status_indicator.FB_Remote_MCB1_Trip_Rapid_CMD}
                                    message_good={"Active"}
                                    message_bad={"Normal State"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"alarming"}
                                    cls_inactive={"normal"}
                                />
                                {
                                    data_status_indicator?.Has_MCB2 === true ?
                                        <>
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"Main MCCB #2"}
                                                value={data_status_indicator.MCB2_Status_On}
                                                message_good={"Status On"}
                                                message_bad={"Status Off"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"normal"}
                                                cls_inactive={"alarming"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"Emergency #2"}
                                                value={data_status_indicator.MCB2_Emergency_Switch}
                                                message_good={"Detected"}
                                                message_bad={"Normal State"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"AC Shutdown #2 CMD"}
                                                value={data_status_indicator.FB_Remote_MCB2_Trip_Main_CMD}
                                                message_good={"Active"}
                                                message_bad={"Normal State"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"DC Shutdown #2 CMD"}
                                                value={data_status_indicator.FB_Remote_MCB2_Trip_Rapid_CMD}
                                                message_good={"Active"}
                                                message_bad={"Normal State"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                        </>
                                        :
                                        null
                                }
                                {
                                    data_status_indicator?.Has_MCB3 === true ?
                                        <>
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"Main MCCB #3"}
                                                value={data_status_indicator.MCB3_Status_On}
                                                message_good={"Status On"}
                                                message_bad={"Status Off"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"normal"}
                                                cls_inactive={"alarming"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"Emergency #3"}
                                                value={data_status_indicator.MCB3_Emergency_Switch}
                                                message_good={"Detected"}
                                                message_bad={"Normal State"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"AC Shutdown #3 CMD"}
                                                value={data_status_indicator.FB_Remote_MCB3_Trip_Main_CMD}
                                                message_good={"Active"}
                                                message_bad={"Normal State"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                            <Indicator
                                                data_ok={local_data_ok}
                                                verify={data_status_indicator.plc_alarm}
                                                name={"DC Shutdown #3 CMD"}
                                                value={data_status_indicator.FB_Remote_MCB3_Trip_Rapid_CMD}
                                                message_good={"Active"}
                                                message_bad={"Normal State"}
                                                message_unknown={"Recieving Status"}
                                                cls_active={"alarming"}
                                                cls_inactive={"normal"}
                                            />
                                        </>
                                        :
                                        null
                                }
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={data_status_indicator.plc_alarm}
                                    name={"Lighting"}
                                    value={data_status_indicator.FB_Remote_Lighting_CMD}
                                    message_good={"Active"}
                                    message_bad={"Off"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"warning-orange"}
                                    cls_inactive={"normal"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={data_status_indicator.plc_alarm}
                                    name={"Buzzer Output"}
                                    value={data_status_indicator.FB_Remote_Buzzer_CMD}
                                    message_good={"Active"}
                                    message_bad={"Off"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"warning-orange"}
                                    cls_inactive={"normal"}
                                />
                            </div>
                            <div className='d-flex flex-wrap mb-3 pb-2 border-bottom'>
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"PLC Controller"}
                                    value={data_status_indicator.plc_alarm}
                                    message_good={"Device OK"}
                                    message_bad={"Comunication Alarm"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"normal"}
                                    cls_inactive={"alarming"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Huawei Logger"}
                                    value={data_status_indicator.logger_alarm}
                                    message_good={"Device OK"}
                                    message_bad={"Comunication Alarm"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"normal"}
                                    cls_inactive={"alarming"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"IOT Module"}
                                    value={data_status_common.iot_device}
                                    message_good={"Device OK"}
                                    message_bad={"Common Alarm"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"normal"}
                                    cls_inactive={"alarming"}
                                />
                                <Indicator
                                    data_ok={local_data_ok}
                                    verify={true}
                                    name={"Grid Meter"}
                                    value={data_status_indicator.meter_grid_alarm}
                                    message_good={"Device OK"}
                                    message_bad={"Comunication Alarm"}
                                    message_unknown={"Recieving Status"}
                                    cls_active={"normal"}
                                    cls_inactive={"alarming"}
                                />
                                {
                                    data_status_indicator?.meter_solar_alarm?.map((meter, index) => (
                                        <Indicator
                                            key={meter.alarm_name}
                                            data_ok={local_data_ok}
                                            verify={true}
                                            name={meter.alarm_name}
                                            value={meter.value}
                                            message_good={"Device OK"}
                                            message_bad={"Common Alarm"}
                                            message_unknown={"Recieving Status"}
                                            cls_active={"normal"}
                                            cls_inactive={"alarming"}
                                        />
                                    ))
                                }
                            </div>
                            <div className='d-flex flex-wrap pb-2 border-bottom'>
                                {
                                    data_status_indicator.inverter_alarm?.map((inv, index) => (
                                        <Indicator
                                            key={"inv-" + inv.alarm_name}
                                            data_ok={local_data_ok}
                                            verify={true}
                                            name={inv.alarm_name}
                                            value={inv.value}
                                            message_good={"Device OK"}
                                            message_bad={"Common Alarm"}
                                            message_unknown={"Recieving Status"}
                                            cls_active={"normal"}
                                            cls_inactive={"alarming"}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ScrollToTopButton />
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default MeasurementIndicator